<template>
  <div>
    <my-table :title="title"
              :searchParams="searchParams"
              :tableData="tableData"
              @pageNumChange="pageNumChange"
              @search="search"
              @keyup.enter.native="keyup()">
      <div slot="table">
        <user-table :tableData="tableData.list"></user-table>
      </div>
    </my-table>

  </div>
</template>

<script>
  import UserTable from "./UserTable";
  import MyTable from "../../components/content/myTable/MyTable";

  import {getUserAll,getUserBySearch,newVue} from "../../network/user"

  export default {
    name: "UserList",
    components: {MyTable,UserTable},
    data(){
      return {
        //标题
        title: "会员资料列表",
        //搜索条件
        searchParams:[
          {
            key:"umsClassify",
            value:"会员类型"
          },
          {
            key:"username",
            value:"用户昵称"
          },
          {
            key:"shareCode",
            value:"用户的分享码"
          },
          {
            key:"phoneNumber",
            value:"用户手机号"
          },
          {
            key:"email",
            value:"用户邮箱"
          }
        ],
        //表格数据以及分页信息
        tableData: {},
        searchItems:{},
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/user/list";
      this.common.HeaderLocationTwo.name =  "注册会员管理"
      this.common.HeaderLocationThree.name = "注册会员列表"
      getUserAll().then(res => {
        this.tableData = res.data;
      })
    },
    methods :{
      pageNumChange(pageNum){
        this.searchEasy(this.searchItems,pageNum);
      },
      search(searchItems){
        this.searchItems = searchItems;
        this.searchEasy(searchItems)
      },
      searchEasy(searchItems,pageNum){
        let umsClassify = null;
        let username = null;
        let phoneNumber = null;
        let email = null;
        let shareCode = null;
        for (let i = 0;i<searchItems.length;i++){
          if (searchItems[i].value === "username"){
            username = searchItems[i].input
          }else if (searchItems[i].value === "umsClassify"){
            umsClassify = searchItems[i].input
          }else if (searchItems[i].value === "phoneNumber"){
            phoneNumber = searchItems[i].input
          }else if (searchItems[i].value === "email"){
            email = searchItems[i].input
          }else if (searchItems[i].value === "shareCode"){
            shareCode = searchItems[i].input
          }
        }
        getUserBySearch(username,umsClassify,phoneNumber,email,shareCode,pageNum).then(res => {
          this.tableData = res.data
        })
      },
      keyup(){
        this.searchEasy(this.searchItems);
      }
    }
  }
</script>

<style scoped>
</style>
